export default __webpack_public_path__ + "static/media/home_web-lg@1x.8e5e0096.webp";